'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _utilElement = require('utils/util-element.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Thankyou = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data.data,
    selectedLanguage: state.survey.selectedLanguage,
    createdAudienceInfo: state.survey.createdAudienceInfo
  };
}, null), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Thankyou, _Component);

  function Thankyou(props) {
    (0, _classCallCheck3.default)(this, Thankyou);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./Thankyou.scss');
    _this.state = {
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      timer: _this.props.survey && _this.props.survey.redirectionCounter ? _this.props.survey.redirectionCounter : 5
    };
    _this.intervalTimer = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading survey thankyou page.');
    return _this;
  }

  Thankyou.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!this.props.code && this.props.redirectFromThankyou) {
      setTimeout(function () {
        window.location.reload();
      }, 15000);
    }
    if (this.props.survey.enableRedirection && this.props.createdAudienceInfo && !this.props.previewMode && !this.props.surveySubmitted) {
      this.intervalTimer = setInterval(function () {
        if (_this2.state.timer <= 0) {
          clearInterval(_this2.intervalTimer);
          window.location.href = _this2.props.createdAudienceInfo.redirectionUrl;
        } else {
          _this2.setState({
            timer: _this2.state.timer - 1
          });
        }
      }, 1000);
    }
  };

  Thankyou.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    if (nextProps.createdAudienceInfo && this.props.createdAudienceInfo !== nextProps.createdAudienceInfo) {
      if (!this.intervalTimer) {
        this.intervalTimer = setInterval(function () {
          if (_this3.state.timer <= 0) {
            clearInterval(_this3.intervalTimer);
            window.location.href = nextProps.createdAudienceInfo.redirectionUrl;
          } else {
            _this3.setState({
              timer: _this3.state.timer - 1
            });
          }
        }, 1000);
      }
    }
  };

  Thankyou.prototype.render = function render() {
    var _props = this.props,
        survey = _props.survey,
        selectedLanguage = _props.selectedLanguage;

    var thankyouMsg = void 0;
    if (this.props.surveySubmitted === true) {
      thankyouMsg = survey && survey.thankYouMessage[survey.feedbackLanguage];
    } else if (this.props.selectedLanguage !== null) {
      thankyouMsg = survey.thankYouMessage[selectedLanguage];
    } else {
      thankyouMsg = 'Thanks for your valuable feedback!';
    }
    var thankyouImg = survey && survey.thankYouImage ? survey.thankYouImage : 'https://static.binaryfountain.com/feedback/v1/Thank-You-Survey-4x.png';
    return _react2.default.createElement(
      'div',
      { className: this.styles.thankyou_container, id: 'thankyou_page' },
      _react2.default.createElement(
        _Row2.default,
        { className: 'show-grid', style: { width: '100%', margin: '0px' } },
        _react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xs: 12, sm: 12, md: 4, lg: 4 },
              _react2.default.createElement(
                'div',
                { className: this.styles.client_logo },
                _react2.default.createElement('img', { src: this.props.clientLogoUrl })
              )
            ),
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 })
          )
        ),
        this.props.survey && this.props.survey.enableRedirection && this.props.createdAudienceInfo && !this.props.previewMode && !this.props.surveySubmitted && _react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xs: 12, sm: 6, md: 4, lg: 4 },
              _react2.default.createElement(
                'div',
                { className: this.styles.testimonial_redirection },
                _react2.default.createElement(
                  'div',
                  null,
                  this.props.survey.redirectionMessage
                )
              )
            ),
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 })
          ),
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xs: 12, sm: 6, md: 4, lg: 4 },
              _react2.default.createElement(
                'div',
                { className: this.styles.testimonial_redirection },
                _react2.default.createElement(
                  'div',
                  { className: this.styles.timer },
                  this.state.timer
                )
              )
            ),
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 2, md: 4, lg: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xsHidden: true, smHidden: true, md: 4, lg: 4 },
              survey && !survey.disableThankYouImage ? _react2.default.createElement(
                'div',
                { className: this.styles.thankyou_img },
                _react2.default.createElement('img', { src: thankyouImg })
              ) : ''
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 8, sm: 8, mdHidden: true, lgHidden: true },
              survey && !survey.disableThankYouImage && !survey.showThankYouMessageForMobileScreen ? _react2.default.createElement(
                'div',
                { className: this.styles.thankyou_img },
                _react2.default.createElement('img', { src: thankyouImg })
              ) : ''
            ),
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 2, md: 4, lg: 4 })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { xsHidden: true, smHidden: true, md: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: this.styles.thankyou_txt },
            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: thankyouMsg } })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, mdHidden: true, lgHidden: true, className: this.styles.thankyou_txt_mobile },
          survey && survey.showThankYouMessageForMobileScreen ? _react2.default.createElement(
            'div',
            { className: this.styles.thankyou_txt },
            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: thankyouMsg } })
          ) : ''
        ),
        this.props.showBranding && _react2.default.createElement(
          _Col2.default,
          { xsHidden: true, smHidden: true, md: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: this.styles.poweredby_label },
            'POWERED BY'
          )
        ),
        this.props.showBranding && _react2.default.createElement(
          _Col2.default,
          { xsHidden: true, smHidden: true, md: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: this.styles.poweredby_logo },
            _react2.default.createElement('img', { src: 'https://cdn.consumerism.pressganey.com/pgforsta.png' })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { md: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: this.styles.praivacy_message },
            _react2.default.createElement(
              'a',
              { href: 'https://www.pressganey.com/legal-privacy' },
              'Privacy Policy'
            )
          )
        )
      )
    );
  };

  return Thankyou;
}(_react.Component), _class2.propTypes = {
  survey: _react.PropTypes.object,
  params: _react.PropTypes.object,
  createdAudienceInfo: _react.PropTypes.object,

  code: _react.PropTypes.string,
  clientLogoUrl: _react.PropTypes.string,
  selectedLanguage: _react.PropTypes.string,
  feedbackLanguage: _react.PropTypes.string,

  previewMode: _react.PropTypes.boolean,
  showBranding: _react.PropTypes.boolean,
  surveySubmitted: _react.PropTypes.boolean,
  redirectFromThankyou: _react.PropTypes.boolean
}, _temp)) || _class);
exports.default = Thankyou;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Thankyou/Thankyou.js
// module id = 2350
// module chunks = 0